import styled from 'styled-components';

export const Scroll = styled.div`
  margin: 0 0 1rem;
  max-height: 340px;
  overflow-y: auto;
`;

export const Content = styled.div`
  margin: 30px 0;
  color: #e6eaec;
  font-size: 16px;
  line-height: normal;
  width: 100%;
`;

export const Table = styled.table`
  border-collapse: collapse;
  margin: 0;
  font-size: 14px;
  th,
  td {
    padding: 0 5px 5px 0;
    text-align: center;
  }
  th {
    text-align: left;
    font-weight: normal;
    font-size: 16px;
    padding-bottom: 10px;
    vertical-align: top;
    font-weight: bold;
    text-align: center;
    &.center {
      text-align: center;
    }
  }
  button {
    margin: 0 0 0 1.6em;
    line-height: 1;
  }
  input,
  select {
    max-width: 90px;
    font-size: 14px;
    padding: 0 10px;
    border-radius: 8px;
    height: 34px;
    cursor: pointer;
    background: #1a2429;
    color: #e6eaec;
    border: 1px solid #3d4952;
    font-family: inherit;
  }
  select {
    padding: 0 28px 0 10px;
    min-width: 172px;
    max-width: 172px;
  }
  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  td > span {
    display: block;
    position: relative;
    /* color: #000; */
  }
  tr:last-of-type td {
    padding-bottom: 0;
  }
`;
